import { createContext } from 'react';

export interface Integration {
    slug: string;
    name: string;
    connected: boolean;
}

interface XeroIntegrationTenant {
    tenantId: string;
    tenantName: string;
    tenantType: string;
    fyEndMonth?: number;
    createdDateUtc: string;
    updatedDateUtc: string;
}

export interface XeroIntegration extends Integration {
    xeroTenants: XeroIntegrationTenant[];
    xeroTenantDefault: XeroIntegrationTenant;
    xeroTenantSelected?: XeroIntegrationTenant;
    xeroTenantLocked?: boolean;
}

export type EmailIntegration = Integration

export type IntegrationSlugs = 'xero' | 'email';

type IntegrationMap = {
    'xero': XeroIntegration;
    'email': EmailIntegration;
};

export interface IntegrationContextType {
    integrations: (XeroIntegration | EmailIntegration)[];
    loading: boolean;
    error: string | null;
    getIntegration<T extends IntegrationSlugs>(slug: T): IntegrationMap[T] | undefined;
    getIntegration(slug: string): undefined;
    refreshIntegrations: () => void;
    setXeroTenant: (tenantId: string) => Promise<void>;
    lockXeroTenant: () => Promise<void>;
    unlockXeroTenant: () => Promise<void>;
}

export const IntegrationContext = createContext<IntegrationContextType | undefined>(undefined);
